<template>
  <div class="criterio-import-customers">
    <p>
      <span>Descrição da lista</span>
      <v-text-field v-model="description" :disabled="disabled" solo hide-details single-line />
    </p>

    <v-row>
      <v-col class="py-0" align="center">
        <mf-button label="Importar clientes" :disabled="disabled" @click="openImportModal = true" />
      </v-col>
    </v-row>

    <import-clients-with-field-select v-model="openImportModal" @objectSelected="formatCustomersList($event)" />
    <p v-if="haveCustomers()" class="qty-customers-found" :style="{ textAlign: 'center' }">{{ getQtyCustomersFoud() }}</p>
  </div>
</template>

<script>
import ImportClientsWithFieldSelect from '@/components/ImportClientsWithFieldSelect.vue'

export default {
  components: {
    ImportClientsWithFieldSelect,
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Object, Number, Array],
      default: () => {
        return []
      },
    },
    values: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    openImportModal: false,
    description: '',
    customersToSave: [],
    valueToSave: {},
  }),

  watch: {
    description(description) {
      this.valueToSave.description = description
      this.$emit('input', { currentValue: this.valueToSave, currentIndex: this.currentIndex })
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.input(this.initialValue)
      this.description = this.initialValue.description || ''
    })
  },

  methods: {
    input(value, isNew) {
      this.valueToSave = this.setValues(value, isNew)
      this.$emit('input', { currentValue: this.valueToSave, currentIndex: this.currentIndex })

      this.validate()
    },

    setValues(value, isNew) {
      if (isNew) {
        return {
          ...(value?.response?.fileUrl
            ? {
                file_url: value?.response?.fileUrl,
              }
            : {
                values: value?.response?.founded,
              }),
          ...(value?.response?.fileUrl
            ? {
                clients_qty_from_file: value?.response?.founded?.length,
              }
            : {}),
          ...(value?.response?.fileUrl
            ? {
                remote: true,
              }
            : {}),
          field: this.getSelectedField(value.selectedField),
          description: this.description,
        }
      } else {
        return {
          ...(value.file_url
            ? {
                file_url: value.file_url,
              }
            : {
                values: value.values,
              }),
          ...(value.file_url
            ? {
                clients_qty_from_file: value.clients_qty_from_file,
              }
            : {}),
          ...(value.file_url
            ? {
                remote: value.remote,
              }
            : {}),
          field: this.getSelectedField(value.field),
          description: this.description,
        }
      }
    },

    getSelectedField(field) {
      if (field === 'cpf_cnpj' || field === 'CPF_CNPJ') return 'CPF_CNPJ'
      else return 'CODIGO'
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean((this.customersToSave.response && this.customersToSave.response.founded) || (this.initialValue && this.initialValue.length))
    },

    formatCustomersList(customers) {
      this.customersToSave = customers
      this.customersToSave.response.founded = this.customersToSave.response.founded.filter((customer) => {
        return Boolean(customer)
      })
      this.input(this.customersToSave, true)
    },

    getQtyCustomersFoud() {
      if (this.customersToSave.founded && this.customersToSave.founded.length) return `${this.customersToSave.response.founded.length} cliente(s) encontrados`
      else if (!this.customersToSave.founded && (this.initialValue?.values?.length || this.initialValue?.clients_qty_from_file))
        return `${this.initialValue?.values?.length || this.initialValue?.clients_qty_from_file} cliente(s) encontrados`
      else return 'Nenhum cliente encontrado'
    },

    haveCustomers() {
      return Boolean(this.customersToSave.response || (this.initialValue.values && this.initialValue.values.length) || this.initialValue?.clients_qty_from_file)
    },
  },
}
</script>

<style lang="scss">
.criterio-import-customers {
  .qty-customers-found {
    margin-top: 12px;
    margin-bottom: 6px;
    color: $cinza-d10;
    font-size: 14px;
  }
}
</style>
